import React from 'react';
import {useLocation, useSearchParams} from "react-router-dom";
import UseContext from "hooks/useContext";
import FeatureBadge from "components/featureBadge/FeatureBadge";

const NavBarTitle = () => {
    const route =useLocation()
    const {pathname}=route
    const path = pathname.split('/')
    const page=path[1]
    const {missionTitle, missionId, language} = UseContext()
    const [searchParams] = useSearchParams()
    const PAGE ={
        'dashboard':'Tableau de bord',
        'profil':'Paramètres de l\'entreprise',
        'timeSheet':'Relevés d\'heures',
        'files':'Documents',
        'missions':'Missions',
        'contract':'Contrats',
        'invoice':'Factures',
        'personalInformations':'Mon Profil',
        'createOfMission':'Création de missions',
        'activityCompany':'Activités',
        'missionTemplates':'Fiches de postes'
    }
    const isMissionCreated = page === 'missionCreated'
    const isMissionTemplateCreate = pathname.includes('/missionTemplates/create')
    const isMissionTemplateEdit = pathname.includes('/missionTemplates/edit')
    
    // Si on est sur une sous-page de profil, afficher "Paramètres de l'entreprise"
    const isProfilPage = pathname.includes('/profil')
    
    // Si on est sur une page de mission détaillée, afficher le titre de la mission
    const isMissionDetailPage = pathname.includes('/mission/') && pathname !== '/missions'

    // Invoice detail: "Facture n°1234", the number comes from the list row.
    const invoiceNumber = pathname === '/invoice/detail' ? searchParams.get('number') : null

    // Job descriptions are a new feature: flagged next to the title of their list.
    const isMissionTemplateList = page === 'missionTemplates' && !isMissionTemplateCreate && !isMissionTemplateEdit
    
    return (
        <>
            <div className="flex items-center gap-2">
                <span className='ft-lg text-gray-700'>
                    {isMissionDetailPage 
                        ? 'Détail de la mission'
                        : isMissionCreated
                            ? language.getValue('missionCreated.navTitle', 'Mission créée')
                        : invoiceNumber
                            ? `${language.getValue('invoice.detailTitle', 'Facture n°')}${invoiceNumber}`
                        : isMissionTemplateCreate
                            ? language.getValue('missionTemplate.pageTitle.create', 'Création d\'une fiche de poste')
                            : isMissionTemplateEdit
                            ? language.getValue('missionTemplate.pageTitle.edit', 'Modification d\'une fiche de poste')
                            : isProfilPage 
                                ? 'Paramètres de l\'entreprise' 
                                : (PAGE[page] || '')
                    }
                </span>
                {isMissionTemplateList ? (
                    <FeatureBadge>{language.getValue('missionTemplate.list.newBadge', 'Nouveau')}</FeatureBadge>
                ) : null}
            </div>
        </>
    );
};

export default NavBarTitle;